import { render } from "./BetanoMagPost.vue?vue&type=template&id=2815cdf6&scoped=true"
import script from "./BetanoMagPost.vue?vue&type=script&lang=js"
export * from "./BetanoMagPost.vue?vue&type=script&lang=js"

import "./BetanoMagPost.vue?vue&type=style&index=0&id=2815cdf6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2815cdf6"]])

export default __exports__